import {
    ModuleWithProviders,
    NgModule,
} from '@angular/core';
import {
    PageCategory,
    PageScope,
    providePageMeta,
} from '@app/router';
import {
    FeatureFlag,
    FolderType,
} from '@models';

@NgModule()
export class TasksMetaModule {
    static forRoot(): ModuleWithProviders {
        return {
            ngModule: TasksMetaModule,
            providers: [
                providePageMeta({
                    title: 'Task Catalogs',
                    translationKey: 'page_taskcatalogs',
                    routerLink: '/tasks/catalogs',
                    sidebarSection: 'Management',
                    svgIcon: 'uipath:taskCatalogIcon',
                    type: 'Sidebar',
                    category: PageCategory.Tenant,
                    featureFlag: FeatureFlag.Tasks,
                    permission: 'TaskCatalogs.View',
                    scope: PageScope.Folder,
                    folderTypeDependency: FolderType.Classic,
                    priority: 5,
                }),
                providePageMeta({
                    title: 'Tasks',
                    translationKey: 'page_tasks',
                    routerLink: '/tasks/view',
                    sidebarSection: 'Automations',
                    permission: 'Tasks.View',
                    svgIcon: 'uipath:taskIcon',
                    type: 'Sidebar',
                    category: PageCategory.Tenant,
                    featureFlag: FeatureFlag.Tasks,
                    scope: PageScope.Global,
                    folderTypeDependency: FolderType.Classic,
                    priority: 4,
                }),
                providePageMeta({
                    title: 'Task Modal',
                    translationKey: 'page_tasks',
                    routerLink: '/tasks/view/:id',
                    permission: 'Tasks.View',
                    category: PageCategory.Tenant,
                    featureFlag: FeatureFlag.Tasks,
                    scope: PageScope.Folder,
                    folderTypeDependency: FolderType.Classic,
                }),
                // provide information for the main (in our case redirected) route
                providePageMeta({
                    title: 'Tasks',
                    translationKey: 'page_tasks',
                    routerLink: '/tasks',
                    permission: 'Tasks.View',
                    svgIcon: 'uipath:taskIcon',
                    category: PageCategory.Tenant,
                    featureFlag: FeatureFlag.Tasks,
                    scope: PageScope.Global,
                    folderTypeDependency: FolderType.Classic,
                    priority: 8,
                }),
            ],
        };
    }
}
